import { render, staticRenderFns } from "./ImgTip.vue?vue&type=template&id=186eaed6&scoped=true"
import script from "./ImgTip.vue?vue&type=script&lang=js"
export * from "./ImgTip.vue?vue&type=script&lang=js"
import style0 from "./ImgTip.vue?vue&type=style&index=0&id=186eaed6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186eaed6",
  null
  
)

export default component.exports